module.exports = __webpack_public_path__ + "static/media/card-posted.3ac95a35.svg";